/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  AgentIDForm,
  AgentIDForm$Outbound,
  AgentIDForm$outboundSchema,
} from "../components/agentidform.js";

export type DeleteAgentSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type DeleteAgentRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  agentIDForm: AgentIDForm;
};

/** @internal */
export type DeleteAgentSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const DeleteAgentSecurity$outboundSchema: z.ZodMiniType<
  DeleteAgentSecurity$Outbound,
  DeleteAgentSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function deleteAgentSecurityToJSON(
  deleteAgentSecurity: DeleteAgentSecurity,
): string {
  return JSON.stringify(
    DeleteAgentSecurity$outboundSchema.parse(deleteAgentSecurity),
  );
}

/** @internal */
export type DeleteAgentRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  AgentIDForm: AgentIDForm$Outbound;
};

/** @internal */
export const DeleteAgentRequest$outboundSchema: z.ZodMiniType<
  DeleteAgentRequest$Outbound,
  DeleteAgentRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    agentIDForm: AgentIDForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      agentIDForm: "AgentIDForm",
    });
  }),
);

export function deleteAgentRequestToJSON(
  deleteAgentRequest: DeleteAgentRequest,
): string {
  return JSON.stringify(
    DeleteAgentRequest$outboundSchema.parse(deleteAgentRequest),
  );
}
